export default "__VITE_ASSET__DQ8GGAPX__"